import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useVuetify } from '@/composables/vuetify'
import CalendarDesktop from './CalendarDesktop.vue'
import CalendarMobile from './CalendarMobile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsCalendarPage',
  setup(__props) {

const vuetify = useVuetify()
const isDesktop = computed(() => vuetify.breakpoint.mdAndUp)

return { __sfc: true,vuetify, isDesktop, CalendarDesktop, CalendarMobile }
}

})